import React, { useState, useEffect } from 'react';
import { Card, DatePicker, Spin, Toast, Descriptions } from '@douyinfe/semi-ui';
import request from '../../utils/request';

const DataCubeCard = ({ dataType, title, dateType, appId }) => {
  const [loading, setLoading] = useState(false);
  const [dateRange, setDateRange] = useState([]);
  const [data, setData] = useState(null);

  const fetchData = async () => {
    setLoading(true);
    try {
      const formatDate = (date) => {
        const year = date.getFullYear();
        const month = (date.getMonth() + 1).toString().padStart(2, '0');
        const day = date.getDate().toString().padStart(2, '0');
        return `${year}${month}${day}`;
      };
      const [beginDate, endDate] = dateRange.map(formatDate);
      const res = await request({
        url: `/go/sp/weixin/xcx_datacube/?uid=${appId}&typ=${dataType}&begin_date=${beginDate}&end_date=${endDate}`,
        method: 'GET',
      });
      if (res.errno === 0) {
        let parsedData = res.data;
        if (typeof res.data === 'string') {
          try {
            parsedData = JSON.parse(res.data);
          } catch (e) {
            console.error('Failed to parse JSON string:', e);
            // 如果解析失败，仍然使用原始字符串
          }
        }
        setData(parsedData);
      } else {
        Toast.error(res.errstr);
      }
    } catch (error) {
      Toast.error('请求数据失败');
      console.error(error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    const today = new Date();
    if (dataType === 'user_portrait') {
      const today = new Date();
      const yesterday = new Date(today);
      yesterday.setDate(today.getDate() - 1);
      const sevenDaysAgo = new Date(yesterday);
      sevenDaysAgo.setDate(yesterday.getDate() - 6);
      setDateRange([sevenDaysAgo, yesterday]);
    } else if (dateType === 'daily') {
      const today = new Date();
      const yesterday = new Date(today);
      yesterday.setDate(today.getDate() - 1);
      setDateRange([yesterday, yesterday]);
    } else if (dateType === 'weekly') {
      // 默认选择上周
      const today = new Date();
      const dayOfWeekToday = today.getDay();
      const lastSunday = new Date(today);
      lastSunday.setDate(today.getDate() - (dayOfWeekToday === 0 ? 7 : dayOfWeekToday));
      lastSunday.setHours(23, 59, 59, 999); // 设置为上周日结束

      const lastWeekStartDate = new Date(lastSunday);
      lastWeekStartDate.setDate(lastSunday.getDate() - 6); // 上周一
      setDateRange([lastWeekStartDate, lastSunday]);
    } else if (dateType === 'monthly') {
      // 默认选择上月
      const lastMonthEndDate = new Date(new Date().getFullYear(), new Date().getMonth(), 0); // 上个月的最后一天
      const lastMonthStartDate = new Date(lastMonthEndDate.getFullYear(), lastMonthEndDate.getMonth(), 1); // 上个月的第一天
      setDateRange([lastMonthStartDate, lastMonthEndDate]);
    }
  }, [dateType]);

  useEffect(() => {
    if (dateRange[0] && dateRange[1] && appId) {
      fetchData();
    }
  }, [dateRange, appId]);

  return (
    <Card style={{ width: 300, marginBottom: 20 }}>
      <h3>{title}</h3>
      <div style={{ marginBottom: 20 }}>
        <DatePicker
          type={dataType === 'user_portrait' ? 'dateRange' : (dateType === 'daily' ? 'date' : 'dateRange')}
          value={dateRange}
          onChange={(date) => {
            if (dataType === 'user_portrait') {
              const selectedEndDate = date[1];
              const selectedBeginDate = date[0];

              if (!selectedEndDate || !selectedBeginDate) {
                setDateRange(date);
                return;
              }

              const diffTime = Math.abs(selectedEndDate.getTime() - selectedBeginDate.getTime());
              const diffDays = Math.ceil(diffTime / (1000 * 60 * 60 * 24));

              let newBeginDate = new Date(selectedEndDate);
              if (diffDays === 0) {
                newBeginDate.setDate(selectedEndDate.getDate());
              } else if (diffDays === 6) {
                newBeginDate.setDate(selectedEndDate.getDate() - 6);
              } else if (diffDays === 29) {
                newBeginDate.setDate(selectedEndDate.getDate() - 29);
              } else {
                Toast.error('开始日期与结束日期相差的天数限定为0/6/29');
                return;
              }
              setDateRange([newBeginDate, selectedEndDate]);
            } else if (dateType === 'daily') {
              setDateRange([date, date]);
            } else if (dateType === 'weekly') {
              // 确保选择的日期范围是一个完整的自然周，且不超过上周
              const selectedDate = date[0];
              const dayOfWeek = selectedDate.getDay();
              let startOfWeek = new Date(selectedDate);
              startOfWeek.setDate(selectedDate.getDate() - dayOfWeek + (dayOfWeek === 0 ? -6 : 1));
              let endOfWeek = new Date(startOfWeek);
              endOfWeek.setDate(startOfWeek.getDate() + 6);

              const today = new Date();
              const dayOfWeekToday = today.getDay();
              const lastSunday = new Date(today);
              lastSunday.setDate(today.getDate() - (dayOfWeekToday === 0 ? 7 : dayOfWeekToday));
              lastSunday.setHours(23, 59, 59, 999); // 设置为上周日结束

              // 如果选择的周的结束日期超过了上周日，则将日期范围设置为上周日所在的完整周
              if (endOfWeek.valueOf() > lastSunday.valueOf()) {
                const lastSundayDayOfWeek = lastSunday.getDay();
                const lastSundayStartOfWeek = new Date(lastSunday);
                lastSundayStartOfWeek.setDate(lastSunday.getDate() - lastSundayDayOfWeek + (lastSundayDayOfWeek === 0 ? -6 : 1));
                const lastSundayEndOfWeek = new Date(lastSundayStartOfWeek);
                lastSundayEndOfWeek.setDate(lastSundayStartOfWeek.getDate() + 6);
                setDateRange([lastSundayStartOfWeek, lastSundayEndOfWeek]);
              } else {
                setDateRange([startOfWeek, endOfWeek]);
              }
            } else if (dateType === 'monthly') {
              // 确保选择的日期范围是一个完整的自然月，且不超过上月
              const selectedDate = date[0];
              let startOfMonth = new Date(selectedDate.getFullYear(), selectedDate.getMonth(), 1);
              let endOfMonth = new Date(selectedDate.getFullYear(), selectedDate.getMonth() + 1, 0);

              const lastDayOfLastMonth = new Date(new Date().getFullYear(), new Date().getMonth(), 0);

              // 如果选择的月的结束日期超过了上个月的最后一天，则将结束日期设置为上个月的最后一天，并相应调整开始日期
              if (endOfMonth.valueOf() > lastDayOfLastMonth.valueOf()) {
                endOfMonth = lastDayOfLastMonth;
                startOfMonth = new Date(endOfMonth.getFullYear(), endOfMonth.getMonth(), 1);
              }
              setDateRange([startOfMonth, endOfMonth]);
            } else {
              setDateRange(date);
            }
          }}
          // 根据 dateType 设置 disabledDate
          disabledDate={(currentDate) => {
            if (dataType === 'user_portrait') {
              const today = new Date();
              today.setHours(0, 0, 0, 0);
              // 允许设置的最大值为昨日
              if (currentDate.valueOf() >= today.valueOf()) {
                return true;
              }
            }

            if (dateType === 'daily') {
              // 按天统计，最多只能选到昨天
              const yesterday = new Date();
              yesterday.setDate(yesterday.getDate() - 1);
              return currentDate.valueOf() > yesterday.valueOf();
            } else if (dateType === 'weekly') {
              // 按周统计，最多只能选到上周日
              const today = new Date();
              const dayOfWeekToday = today.getDay();
              const lastSunday = new Date(today);
              lastSunday.setDate(today.getDate() - (dayOfWeekToday === 0 ? 7 : dayOfWeekToday));
              lastSunday.setHours(23, 59, 59, 999); // 设置为上周日结束
              return currentDate.valueOf() > lastSunday.valueOf();
            } else if (dateType === 'monthly') {
              // 按月统计，最多只能选到上个月的最后一天
              const lastDayOfLastMonth = new Date(new Date().getFullYear(), new Date().getMonth(), 0);
              return currentDate.valueOf() > lastDayOfLastMonth.valueOf();
            }
            return false;
          }}
          style={{ width: '100%' }}
        />
      </div>
      <Spin spinning={loading} dot>
        {data ? (
          <div>
            {dataType === 'daily_visit' && data && data.list && data.list.length > 0 ? (
              <Descriptions align="left" data={[
                { key: '日期', value: data.list[0].ref_date.replace(/(\d{4})(\d{2})(\d{2})/, '$1-$2-$3') },
                { key: '会话数', value: data.list[0].session_cnt },
                { key: '访问次数', value: data.list[0].visit_pv },
                { key: '访问人数', value: data.list[0].visit_uv },
                { key: '新用户数', value: data.list[0].visit_uv_new },
                { key: '人均停留时长', value: data.list[0].stay_time_uv },
                { key: '次均停留时长', value: data.list[0].stay_time_session },
                { key: '平均访问深度', value: data.list[0].visit_depth },
              ]} />
            ) : dataType === 'monthly_visit' && data && data.list && data.list.length > 0 ? (
              <Descriptions align="left" data={[
                { key: '日期', value: data.list[0].ref_date.replace(/(\d{4})(\d{2})/, '$1-$2') },
                { key: '会话数', value: data.list[0].session_cnt },
                { key: '访问次数', value: data.list[0].visit_pv },
                { key: '访问人数', value: data.list[0].visit_uv },
                { key: '新用户数', value: data.list[0].visit_uv_new },
                { key: '人均停留时长', value: data.list[0].stay_time_uv },
                { key: '次均停留时长', value: data.list[0].stay_time_session },
                { key: '平均访问深度', value: data.list[0].visit_depth },
              ]} />
            ) : dataType === 'weekly_visit' && data && data.list && data.list.length > 0 ? (
              <Descriptions align="left" data={[
                { key: '日期', value: data.list[0].ref_date },
                { key: '会话数', value: data.list[0].session_cnt },
                { key: '访问次数', value: data.list[0].visit_pv },
                { key: '访问人数', value: data.list[0].visit_uv },
                { key: '新用户数', value: data.list[0].visit_uv_new },
                { key: '人均停留时长', value: data.list[0].stay_time_uv },
                { key: '次均停留时长', value: data.list[0].stay_time_session },
                { key: '平均访问深度', value: data.list[0].visit_depth },
              ]} />
            ) : dataType === 'daily_summary' && data && data.list && data.list.length > 0 ? (
              <Descriptions align="left" data={[
                { key: '日期', value: data.list[0].ref_date.replace(/(\d{4})(\d{2})(\d{2})/, '$1-$2-$3') },
                { key: '累计用户数', value: data.list[0].visit_total },
                { key: '分享PV', value: data.list[0].share_pv },
                { key: '分享UV', value: data.list[0].share_uv },
              ]} />
            ) : dataType === 'daily_retain' && data ? (
              <Descriptions align="left" data={[
                { key: '日期', value: data.ref_date ? data.ref_date.replace(/(\d{4})(\d{2})(\d{2})/, '$1-$2-$3') : 'N/A' },
                { key: '新增用户留存', value: data.visit_uv_new && data.visit_uv_new.map((item, index) => <span key={index}>第{item.key}天留存: {item.value}<br /></span>) },
                { key: '活跃用户留存', value: data.visit_uv && data.visit_uv.map((item, index) => <span key={index}>第{item.key}天留存: {item.value}<br /></span>) },
              ]} />
            ) : dataType === 'monthly_retain' && data ? (
              <Descriptions align="left" data={[
                { key: '日期', value: data.ref_date ? data.ref_date.replace(/(\d{4})(\d{2})/, '$1-$2') : 'N/A' },
                { key: '新增用户留存', value: data.visit_uv_new && data.visit_uv_new.map((item, index) => <span key={index}>第{item.key}月留存: {item.value}<br /></span>) },
                { key: '活跃用户留存', value: data.visit_uv && data.visit_uv.map((item, index) => <span key={index}>第{item.key}月留存: {item.value}<br /></span>) }
              ]} />
            ) : dataType === 'weekly_retain' && data ? (
              <Descriptions align="left" data={[
                { key: '日期', value: data.ref_date ? data.ref_date.replace(/(\d{4})(\d{2})(\d{2})/, '$1-$2-$3') : 'N/A' },
                { key: '新增用户留存', value: data.visit_uv_new && data.visit_uv_new.map((item, index) => <span key={index}>第{item.key}周留存: {item.value}<br /></span>) },
                { key: '活跃用户留存', value: data.visit_uv && data.visit_uv.map((item, index) => <span key={index}>第{item.key}周留存: {item.value}<br /></span>) }
              ]} />
            ) : dataType === 'page_visit' && data && data.list ? (
              <Descriptions align="left" data={[
                { key: '日期', value: data.ref_date ? data.ref_date.replace(/(\d{4})(\d{2})(\d{2})/, '$1-$2-$3') : 'N/A' },
                ...(data.list ? data.list.map((item, index) => ({
                  key: `${index + 1}`,
                  value: (
                    <>
                      页面: {item.page_path}<br />
                      访问PV: {item.page_visit_pv}<br />
                      访问UV: {item.page_visit_uv}<br />
                      页面停留时长PV: {item.page_staytime_pv}<br />
                      入口页PV: {item.entrypage_pv}<br />
                      退出页PV: {item.exitpage_pv}<br />
                      页面分享PV: {item.page_share_pv}<br />
                      页面分享UV: {item.page_share_uv}
                    </>
                  )
                })) : [])
              ]} />
            ) : dataType === 'user_portrait' && data ? (
              <Descriptions align="left" data={[
                { key: '日期', value: data.ref_date ? data.ref_date.replace(/(\d{4})(\d{2})(\d{2})/, '$1-$2-$3') : 'N/A' },
                {
                  key: '新用户画像', value: data.visit_uv_new && Object.entries(data.visit_uv_new).map(([category, items]) => {
                    const categoryMap = {
                      province: '省份',
                      city: '城市',
                      genders: '性别',
                      platforms: '平台类型',
                      devices: '终端类型',
                      ages: '年龄',
                    };
                    return (
                      <div key={category}>
                        <strong>{categoryMap[category] || category}:</strong>
                        <ul>
                          {items.map((item, index) => (
                            <li key={index}>{item.name}: {item.value}</li>
                          ))}
                        </ul>
                      </div>
                    );
                  })
                },
                {
                  key: '活跃用户画像', value: data.visit_uv && Object.entries(data.visit_uv).map(([category, items]) => {
                    const categoryMap = {
                      province: '省份',
                      city: '城市',
                      genders: '性别',
                      platforms: '平台类型',
                      devices: '终端类型',
                      ages: '年龄',
                    };
                    return (
                      <div key={category}>
                        <strong>{categoryMap[category] || category}:</strong>
                        <ul>
                          {items.map((item, index) => (
                            <li key={index}>{item.name}: {item.value}</li>
                          ))}
                        </ul>
                      </div>
                    );
                  })
                },
              ]} />
            ) : dataType === 'visit_distribution' && data && data.list && data.list.length > 0 ? (
              <Descriptions align="left" data={[
                { key: '日期', value: data.ref_date.replace(/(\d{4})(\d{2})(\d{2})/, '$1-$2-$3') },
                {
                  key: '访问分布', value: data.list.map((item) => {
                    let indexDescription = '';
                    let itemMap = {};

                    const commonItemMap = {
                      '1': '小程序历史列表',
                      '2': '搜索',
                      '3': '会话',
                      '4': '扫一扫二维码',
                      '5': '公众号主页',
                      '6': '聊天顶部',
                      '7': '系统桌面',
                      '8': '小程序主页',
                      '9': '附近的小程序',
                      '11': '模板消息',
                      '12': '客服消息',
                      '13': '公众号菜单',
                      '14': 'APP分享',
                      '15': '支付完成页',
                      '16': '长按识别二维码',
                      '17': '相册选取二维码',
                      '18': '公众号文章',
                      '19': '钱包',
                      '20': '卡包',
                      '21': '小程序内卡券',
                      '22': '其他小程序',
                      '23': '其他小程序返回',
                      '24': '卡券适用门店列表',
                      '25': '搜索框快捷入口',
                      '26': '小程序客服消息',
                      '27': '公众号下发',
                      '28': '系统会话菜单',
                      '29': '任务栏-最近使用',
                      '30': '长按小程序菜单圆点',
                      '31': '连wifi成功页',
                      '32': '城市服务',
                      '33': '微信广告',
                      '34': '其他移动应用',
                      '35': '发现入口-我的小程序',
                      '36': '任务栏-我的小程序',
                      '37': '微信圈子',
                      '38': '手机充值',
                      '39': 'H5',
                      '40': '插件',
                      '41': '大家在用',
                      '42': '发现页',
                      '43': '浮窗',
                      '44': '附近的人',
                      '45': '看一看',
                      '46': '朋友圈',
                      '47': '企业微信',
                      '48': '视频',
                      '49': '收藏',
                      '50': '微信红包',
                      '51': '微信游戏中心',
                      '52': '摇一摇',
                      '53': '公众号导购消息',
                      '54': '识物',
                      '55': '小程序订单',
                      '56': '小程序直播',
                      '57': '群工具',
                      '10': '其他',
                    };

                    if (item.index === 'access_source_session_cnt') {
                      indexDescription = '访问来源分布 (会话数)';
                      itemMap = commonItemMap;
                    } else if (item.index === 'access_source_visit_uv') {
                      indexDescription = '访问来源分布 (访问人数)';
                      itemMap = commonItemMap;
                    } else if (item.index === 'access_staytime_info') {
                      indexDescription = '访问时长分布';
                      itemMap = {
                        '1': '0-2s',
                        '2': '3-5s',
                        '3': '6-10s',
                        '4': '11-20s',
                        '5': '20-30s',
                        '6': '30-50s',
                        '7': '50-100s',
                        '8': '>100s',
                      };
                    } else if (item.index === 'access_depth_info') {
                      indexDescription = '访问深度的分布';
                      itemMap = {
                        '1': '1 页',
                        '2': '2 页',
                        '3': '3 页',
                        '4': '4 页',
                        '5': '5 页',
                        '6': '6-10 页',
                        '7': '>10 页',
                      };
                    }

                    return (
                      <>
                        {indexDescription}:<br />
                        {item.item_list.map((subItem) => (
                          <span key={subItem.key}>{itemMap[subItem.key] || subItem.key}: {subItem.value}<br /></span>
                        ))}
                      </>
                    );
                  }).map((item, index) => <div key={index}>{item}</div>)
                },
              ]} />
            ) : (
              <p>暂无数据</p>
            )}
          </div>
        ) : (
          <p>请选择日期查看数据</p>
        )}
      </Spin>
    </Card>
  );
};

export default DataCubeCard;